import { v4 as uuid } from 'uuid';
import { IError } from '../../types';
import RootGizmo from '../root-gizmo';

interface IParams {
  context: {
    rootGizmo: RootGizmo;
  };
}

/**
 * Run the root gizmo specific validations
 * @returns
 */
async function validate({ context }: IParams): Promise<IError[]> {
  const { rootGizmo } = context;
  const config = rootGizmo.getConfig();

  const errors: IError[] = [];

  if (config.ops?.form?.status?.onCreate?.required?.isRequired) {
    const create = rootGizmo.getInfoCB({
      type: 'rootGizmoDataCreate',
    });

    if (create) {
      const data = rootGizmo.getData();

      if (!data?.status) {
        errors.push({
          fid: uuid(),
          code: 'root_gizmo.status.required',
          message: 'Se requiere especificar el status',
        });
      }
    }
  }

  rootGizmo.errors.next(errors);

  return errors;
}

export default validate;
